import React from "react";
import { Modal, Form, Button, Spinner } from "react-bootstrap";

interface CommentModalProps {
    isOpenComment: boolean;
    onClose: () => void;
    onSave: () => void;
    comment: string;
    setComment: (value: string) => void;
    participantName?: string;
    loading?: boolean;
}

export const CommentModal: React.FC<CommentModalProps> = ({
    isOpenComment,
    onClose,
    onSave,
    comment,
    setComment,
    participantName = "",
    loading = false,
}) => {
    return (
        <Modal
            show={isOpenComment}
            onHide={onClose}
            centered
            className="custom_popup aging-comment-modal with_close_icon"
            size="lg"
            backdrop={loading ? "static" : true}
            keyboard={!loading}
        >
            <Modal.Header closeButton={!loading} className="aging-comment-modal-header mb-3">
                <Modal.Title className="aging-comment-modal-title">
                    Comment{participantName ? ` - ${participantName}` : ""}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="aging-comment-modal-body">
                <Form>
                    <Form.Group className="mb-0">
                        <Form.Label className="aging-comment-label">Add/Edit Comment</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Enter your comment here..."
                            disabled={loading}
                            className="aging-comment-textarea"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer className="aging-comment-modal-footer">
                <Button
                    variant="outline-secondary"
                    onClick={onClose}
                    disabled={loading}
                    className="aging-comment-cancel-btn"
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={onSave}
                    disabled={loading}
                    className="aging-comment-save-btn"
                >
                    {loading ? <span><Spinner size='sm' /> Saving...</span> : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
